import React from 'react';
import { LayoutDashboard, BarChart3, Users, MousePointerClick, Mail, Lightbulb } from 'lucide-react';

const TabNavigation = ({ activeTab, setActiveTab, unreadMessagesCount = 0 }) => {
  const tabs = [
    { id: 'overview', label: 'OVERVIEW', icon: <LayoutDashboard className="tab-icon" /> },
    { id: 'analytics', label: 'TRAFFIC & DEMOGRAPHICS', icon: <BarChart3 className="tab-icon" /> },
    { id: 'visitors', label: 'VISITORS LOG', icon: <Users className="tab-icon" /> },
    { id: 'clicks', label: 'CLICKS & EVENTS', icon: <MousePointerClick className="tab-icon" /> },
    { 
      id: 'messages', 
      label: 'CONTACT INBOX', 
      icon: <Mail className="tab-icon" />,
      badge: unreadMessagesCount > 0 ? unreadMessagesCount : null 
    },
    { id: 'insights', label: 'SYSTEM INSIGHTS', icon: <Lightbulb className="tab-icon" /> }
  ];

  return (
    <div className="tab-nav-bar">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`nav-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.icon}
          <span>{tab.label}</span>
          {tab.badge && (
            <span className="tab-badge-pill">{tab.badge}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
